// extracted by mini-css-extract-plugin
export var activeFilter = "styles-mod--active-filter--5d926";
export var categories = "styles-mod--categories--7afe3";
export var categoriesFilters = "styles-mod--categories-filters--57217";
export var clearFilters = "styles-mod--clear-filters--3bf90";
export var closeMobileBox = "styles-mod--close-mobile-box--c3c6a";
export var customCheckbox = "styles-mod--custom-checkbox--11749";
export var disableBtn = "styles-mod--disable-btn--c91b5";
export var disabledFilter = "styles-mod--disabled-filter--87015";
export var dropdownBox = "styles-mod--dropdown-box--087d4";
export var dropdownCategories = "styles-mod--dropdown-categories--bfabc";
export var filterIcon = "styles-mod--filter-icon--ade0e";
export var filtersSummary = "styles-mod--filters-summary--4211a";
export var mobileFilters = "styles-mod--mobile-filters--a1fae";
export var prFilter = "styles-mod--pr-filter--b49f0";
export var primaryFilters = "styles-mod--primary-filters--dd1b0";
export var recipe = "styles-mod--recipe--ee905";
export var recipeImg = "styles-mod--recipe-img--3afaa";
export var recipesCategorySection = "styles-mod--recipes-category-section--e4d39";
export var removeCloseFilters = "styles-mod--remove-close-filters--fe783";
export var secFilter = "styles-mod--sec-filter--33e84";
export var secFilterItems = "styles-mod--sec-filter-items--d230c";
export var secondaryFilters = "styles-mod--secondary-filters--771d4";
export var secondaryFiltersBox = "styles-mod--secondary-filters-box--d49f6";
export var sectionStyle = "styles-mod--section-style--651a9";
export var singleRecipe = "styles-mod--single-recipe--57cdc";
export var text = "styles-mod--text--b51db";
export var title = "styles-mod--title--f0eca";